<template>
  <div>
    <div v-if="show == 'false'">
      <div class="page2_head">
        <div style="font-size: 0.12rem; color: #86909c; margin-bottom: 0.12rem">
          认证前请确认已达到认证要求，不符合要求将不予通过认证
        </div>
        <div style="color: hsl(222, 100%, 54%); font-size: 0.14rem">
          <span>1、实名认证</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <span>2、近 28 天内发布公开作品数不少于 1 部</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>3、职业相关证明材料完备</span>
        </div>
      </div>
      <el-form style="width: 6.4rem" ref="ruleFormRef" :model="ruleForm" label-width="100px" class="demo-ruleForm"
        :size="formSize" status-icon :rules="rules" label-position="left">
        <el-form-item label="个人微信" prop="wechat">
          <el-input v-model="ruleForm.wechat" placeholder="请输入个人微信" />
        </el-form-item>

        <el-form-item label="昵称" prop="name">
          <el-input v-model="username" disabled placeholder="请输入昵称" />
        </el-form-item>

        <el-form-item label="职业" prop="professId">
          <el-select v-model="ruleForm.professId" placeholder="请选择">
            <el-option v-for="item in hangyelist" :key="item.id" :label="item.memberClass" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="入行年份" prop="enterIn">
          <el-date-picker v-model="ruleForm.enterIn" type="year" placeholder="请选择入行年份" />
        </el-form-item>

        <el-form-item label="所在地区" prop="provinceId">
          <el-cascader ref="areas" :props="props" v-model="ruleForm.provinceId" placeholder="请选择"
            :show-all-levels="false"></el-cascader>
        </el-form-item>
        <el-form-item label="证明材料" prop="images">
          <el-upload :action="upload_showImage" list-type="picture-card" :auto-upload="true" multiple
            :ref="(el) => (upload[index] = el)" limit="6" :on-success="onSuccess"
            :on-change="(file, fileList) => handleChange(file, fileList, index)" :on-exceed="handleExceed"
            :file-list="fileList" :on-remove="handleRemove">
            <el-icon>
              <Plus />
            </el-icon>

            <template #file="{ file }">
              <div>
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                <el-image :src="require('@/assets/module_share_open.png')" @click="handleRemove(file, index, 0)"
                  class="img-Off" />
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <el-icon><zoom-in /></el-icon>
                  </span>
                  <!-- <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleDownload(file)"
                  >
                    <el-icon>
                      <Download />
                    </el-icon>
                  </span>
               -->
                </span>
              </div>
            </template>
          </el-upload>
          <el-dialog width="300px" title="预览" v-model="dialogVisible" :close-on-click-modal="false">
            <img w-full style="width: 90%" :src="dialogImageUrl" alt="Preview Image" />
          </el-dialog>
          <div style="font-size: 0.12rem; color: #86909c; margin-top: 0.24rem">
            请上传名片、工牌、学生证、作品署名的图片、官方获奖记录或其他能证明认证说明和职业身份的材料，最多六张。
          </div>
        </el-form-item>
      </el-form>
      <div style="display: flex">
        <div class="dataBtn" @click="onSubmit">提交</div>
      </div>
    </div>
    <!-- 申请成功 -->
    <div style="padding: 1.4rem 0" v-if="show == 'success'">
      <div style="width: 0.48rem; height: 0.48rem; margin: 0 auto">
        <img style="width: 100%; height: 100%" src="@/assets/img/tips／check-circle-fill@2x.png" />
      </div>
      <div style="
          font-size: 0.14rem;
          text-align: center;
          margin-top: 0.16rem;
          margin-bottom: 0.04rem;
          color: #333333;
        ">
        操作成功
      </div>
      <div style="color: #86909c; font-size: 0.14rem; text-align: center">
        等待工作人员审核，预计1-5个工作日
      </div>
    </div>
    <!-- 申请失败 -->
    <div style="padding: 1.4rem 0" v-if="show == 'error'">
      <div style="width: 0.48rem; height: 0.48rem; margin: 0 auto">
        <img style="width: 100%; height: 100%" src="@/assets/img/tips／close-circle-fill@2x.png" />
      </div>
      <div style="
          font-size: 0.14rem;
          text-align: center;
          margin-top: 0.16rem;
          margin-bottom: 0.04rem;
          color: #333333;
        ">
        认证失败
      </div>
      <div style="color: #86909c; font-size: 0.14rem; text-align: center">
        您提交的证明材料不足以证明您的职业
      </div>
      <div class="editBtn" @click="cz">修改信息</div>
    </div>
    <!-- 认证成功 -->
    <div style="padding: 1.4rem 0" v-if="show == 'authentication'">
      <div style="text-align: center; color: #00b42a">认证已完成</div>
      <div class="editBtn" @click="cz1">修改信息</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive } from "vue";
import { Delete, Download, Plus, ZoomIn } from "@element-plus/icons-vue";
import { ElMessage, UploadFile, UploadProps } from "element-plus";
import { serverBaseUrl } from "@/assets/js/ls_tgServerUrls.js";
import { Axios } from "../../../assets/js/ls_com_axios.js";
import { log } from "console";
let show = ref("false");

const upload_showImage = ref(serverBaseUrl + "/file/upload");
console.log(111111);
console.log(upload_showImage);
const formSize = ref("default");
const username = ref("");
const percentageValue = 30;
const progressValue = (percentage: any) =>
  percentage === 100 ? "100%" : `${percentage}%`;
// do not use same name with ref
const ruleForm = ref({
  districtId: 0,
  enterIn: 0,
  images: [] as any,
  professId: "",
  provinceId: 0,
  wechat: "",
});
const upload = ref([]);
const ruleFormRef = ref();
const rules = reactive({
  wechat: [{ required: true, message: "不能为空！", trigger: "change" }],
  professId: [{ required: true, message: "不能为空！", trigger: "change" }],
  images: [{ required: true, message: "不能为空！", trigger: "change" }],
});
const fileList = ref([]);
// 上传前
const allowedExtensions = [".png", ".jpg", ".jpeg"];
const handleChange = (uploadFile: any, uploadFiles: any, index) => {
  if (
    allowedExtensions.indexOf(
      uploadFile.name
        .substring(uploadFile.name.lastIndexOf("."))
        .toLocaleLowerCase()
    ) == -1
  ) {
    upload.value[index].handleRemove(uploadFile);
    ElMessage.warning("格式不正确");
    return;
  }
};
const cz = (e: any) => {
  show.value = "false";
  ruleForm.value = {
    districtId: 0,
    enterIn: 0,
    images: [] as any,
    professId: "",
    provinceId: 0,
    wechat: "",
  };
};
const cz1 = (e: any) => {
  Axios("GET", "/member/login-profession-info", null, false, function (res) {
    show.value = "false";
    ruleForm.value = res.data.data
    if (!ruleForm.value.images) {
      ruleForm.value.images = []
    }
  });
  // show.value = "false";
  // ruleForm.value = {
  //   districtId: 0,
  //   enterIn: 0,
  //   images: [] as any,
  //   professId: "",
  //   provinceId: 0,
  //   wechat: "",
  // };
};
const onSubmit = () => {
  ruleFormRef.value.validate((valid: any) => {
    if (valid) {
      // console.log(ruleForm.value.enterIn);

      let obj = { ...ruleForm.value };

      if (ruleForm.value.provinceId) {
        let pro = ruleForm.value.provinceId[0];
        let dis = ruleForm.value.provinceId[1];
        obj.provinceId = pro;
        obj.districtId = dis;
      }
      let dd = "";
      ruleForm.value.enterIn ? (dd = ruleForm.value.enterIn.getFullYear()) : "";
      console.log("----" + dd);
      console.log(dd);
      dd ? (obj.enterIn = parseInt(dd)) : ""; // 提取年份信息

      onSubmitAxios(obj).then(() => {
        ElMessage.success("操作成功");
        // setTimeout(() => {
        //   show.value = "error";
        // }, 1000);
        show.value = "success";
        getInfo();
      });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
//保存接口
const onSubmitAxios = (obj: any) => {
  //resolve, reject    resolve 成功  reject 失败
  return new Promise((resolve, reject) => {
    Axios("POST", "/member/professinal-cert", obj, false, function (res: any) {
      if (res.data.code == 200) {
        resolve(res.data);
      } else {
        reject();
      }
    });
  });
};

const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const disabled = ref(false);

const handleRemove = (file, index, subIndex) => {
  // 在这里处理文件移除操作
  if (
    upload.value[index] &&
    typeof upload.value[index].handleRemove === "function"
  ) {
    upload.value[index].handleRemove(file, subIndex);
    fileList.value.splice(
      fileList.value.findIndex((item) => item.url === file.url),
      1
    );
    ruleForm.value.images.splice(
      fileList.value.findIndex((item) => item.url === file.url),
      1
    );
  }
};

const handlePictureCardPreview = (file: UploadFile) => {
  dialogImageUrl.value = file.url!;
  dialogVisible.value = true;
};

const handleDownload = (file: UploadFile) => { };

const handleExceed: UploadProps["onExceed"] = (files, uploadFiles) => {
  ElMessage.warning("资料最多上传六张");
};
const onSuccess = (res: any, file: any, fileList1: any) => {
  ruleForm.value.images.push(res.data.url);
  fileList.value.push({
    url: res.data.url,
    name: res.data.name,
    name1: res.data.name.split("?")[0],
  });
};

/**
 * 行业类型请求
 */
const hangyelist = ref([]);
const hangyetypoe = function () {
  let params = {
    memberType: "CREATOR",
  };
  Axios("GET", "/member/type/listby", params, false, function (res: any) {
    hangyelist.value = res.data.data;
  });
};
hangyetypoe();

/**
 * 所在地区
 */
const props = {
  lazy: true,
  lazyLoad(node: any, resolve: any) {
    const { level, id } = node;
    if (level == 0) {
      areaaxios(resolve, 1, 0);
    } else if (level == 1) {
      areaaxios(resolve, node.data.value, 1);
    }
  },
};
const addresList = ref([] as any);
const areaaxios = (resolve: any, pid: any, level: any) => {
  let params = {
    pid: pid,
  };
  Axios("GET", "/system/district/list-all", params, false, function (res: any) {
    const list: { label: any; value: any; leaf: any }[] = [];
    res.data.data.forEach((element: any) => {
      list.push({
        label: element.districtName,
        value: element.id,
        leaf: level >= 1,
      });
    });
    list.length == 34 ? (addresList.value = list) : "";
    // ruleForm.value.provinceName =list
    resolve(list);
  });
};

const areaaxios1 = (pid: any) => {
  return new Promise((resolve, reject) => {
    let params = {
      pid: pid,
    };
    Axios(
      "GET",
      "/system/district/list-all",
      params,
      false,
      function (res: any) {
        const list: { label: any; value: any; leaf: any }[] = [];
        res.data.data.forEach((element: any) => {
          list.push({
            label: element.districtName,
            value: element.id,
          });
        });
        resolve(list);
      }
    );
  });
};

const getInfo = (value: any) => {
  Axios("get", `/member/login-info`, {}, false, (res) => {
    let data = res.data.data;
    if (data.professionalStatus == 0) {
      show.value = "false";
    } else if (data.professionalStatus == 1) {
      show.value = "success";
    } else if (data.professionalStatus == 2) {
      show.value = "authentication";
    } else {
      show.value = "error";
    }

    username.value = data.nickName;
  });
};
getInfo();
</script>

<style scoped>
.upload-demo {
  width: 1.2rem;
  height: 1.2rem;
}

.dataBtn {
  width: 2.68rem;
  padding: 0.12rem 1.06rem;
  background: #C01A26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #fff;
  cursor: pointer;
}

.page2_head {
  width: 12rem;
  background: #f2f3f5;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  opacity: 1;
  padding: 0.16rem;
  box-sizing: border-box;
  margin-bottom: 0.24rem;
}

/deep/.el-upload-dragger {
  width: 100%;
  height: 100%;
  padding: 0 !important;
  box-sizing: border-box !important;
}

.editBtn {
  width: 0.88rem;
  height: 0.37rem;
  line-height: 0.37rem;
  text-align: center;
  background: #C01A26;
  color: #fff;
  margin: 0 auto;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  margin-top: 0.3rem;
  opacity: 1;
  cursor: pointer;
}

/deep/.el-upload-dragger {
  background: #f5f5f5;
}

/deep/.el-upload__input {
  display: none !important;
}

.img-Off {
  position: absolute;
  left: 110px;
  top: 0;
  width: 40px;
  height: 40px;
  z-index: 3;
}
</style>
